import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { mapAnalysisToBrand } from '../../utils/mapAnalysisToBrand';
import { useAuthStore } from '../../store/authStore';

/**
 * OnboardingBanner component.
 *
 * Renders a hero-style banner that lets users choose their onboarding path.
 * Includes a URL input to directly analyze a website and fast-forward setup.
 */
const OnboardingBanner: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuthStore();

  // Derive first name for personalization
  const rawFirstName = user?.firstName || (user?.name ? user.name.split(' ')[0] : '');
  const firstName = rawFirstName
    ? rawFirstName.charAt(0).toUpperCase() + rawFirstName.slice(1)
    : '';

  return (
    <div className="relative overflow-hidden rounded-2xl border border-black bg-[#0a5ad8]">
      <div className="relative z-10 p-6 md:p-10">
        <h2 className="font-title text-2xl font-bold text-white md:text-3xl">
          {t('onboarding.banner.title', { firstName })}
        </h2>
        <div className="mt-3 text-white/90 leading-relaxed">
          <p>{t('onboarding.banner.featuresIntro', 'Go through your own onboarding to enjoy our unique features:')}</p>
          <ul className="mt-2 list-disc pl-6 columns-1 md:columns-3 [column-fill:_balance] gap-6">
            <li>{t('brands.title', 'Brand Strategy Lab')}</li>
            <li>{t('personas.title', 'AI Persona Builder')}</li>
            <li>{t('contentCreation.title', 'AI Content Studio')}</li>
            <li>{t('boostMode.title', 'Boost Mode')}</li>
            <li>{t('accounts.title', 'Social Media Hub')}</li>
            <li>{t('teamMembers.title', 'Team Hub')}</li>
            <li>{t('calendar.title', 'Smart Content Calendar')}</li>
            <li>{t('sidebar.aiLinksBuilder', 'AI Link Builder & Shortener')}</li>
            <li>{t('analytics.title', 'Performance Coach Analytics')}</li>
            <li>{t('cards.approval.title', 'Approval Workflow')}</li>
            <li>{t('cards.aiContent.title', 'Smart Visual Creator')}</li>
            <li>{t('mediaGallery.title', 'Media Gallery')}</li>
          </ul>
          <p className="mt-3">{t('onboarding.banner.supportHint', 'Have any question? Reach out to us via the chat on the bottom right.')}</p>
        </div>

      </div>
    </div>
  );
};

export default OnboardingBanner;


